import { Box, IconButton, InputAdornment, styled, TextField, Typography } from '@mui/material'
import { useSizeWindow } from 'Helpers/GlobalHelpers'
import { observer } from 'mobx-react-lite'
import { DefaultLabelTypo, DefaultInputStyled } from './InputsStyled'
import { useState } from 'react'
import { Visibility, VisibilityOff } from '@mui/icons-material'
import { ReactComponent as PasswordShowIcon } from './Assets/password-show.svg'
import { ReactComponent as SearchIcon } from './Assets/SearchIcon.svg'
import PasswordHideIcon from './Assets/PasswordHideIcon';

const DefaultInput = observer(props => {
    const { width } = useSizeWindow()
    const [showPassword, setShowPassword] = useState(false)
    const {
        //filled-error-helper-text  id should be unique
        label = '',
        value = '',
        fullWidth = true,
        onChange,
        onBlur = () => { },
        type = 'text',
        error = true,
        helpertext = '',
        paddingleft = 16,
        helpertextcardtype,
        typeKey,
        onKeyUp,
        placeholder = '',
        endAdornmentToggle = () => { }
    } = props

    const handleTogglePasswordVisibility = (value) => {
        if (value.length === 0) return
        setShowPassword(!showPassword)
    }

    const handleToggleZipSearch = () => {
        endAdornmentToggle(true)
    }
    // SearchIcon

    const getEndAdornment = (type = null, value = "") => {
        let endAdornment = <></>

        switch (type) {
            case 'password':
                const hideIconStrokeColor = value.length > 0 ? '#5A8FC3' : '#D1D9E2'
                endAdornment = (
                    <InputAdornment position="end">
                        <IconButton onClick={() => handleTogglePasswordVisibility(value)} edge="end" disableRipple>
                            {!showPassword ? <PasswordHideIcon strokeColor={hideIconStrokeColor} /> : <PasswordShowIcon />}
                        </IconButton>
                    </InputAdornment>
                )
                break
            case 'zipSearch':
                endAdornment = (
                    <InputAdornment position="end">
                        <IconButton onClick={handleToggleZipSearch} edge="end">
                            <SearchIcon width={'18px'} height={'18px'} />
                        </IconButton>
                    </InputAdornment>
                )
                break
            default:
                endAdornment = null
                break
        }

        return endAdornment
    }

    const getRealType = (type = 'text') => {
        let realType = type
        switch (type) {
            case 'password':
                if (showPassword) {
                    realType = 'text'
                }
                break
            case 'zipSearch':
                realType = 'tel'
                break
            default:
                realType = type
                break
        }
        return realType
    }

    return (
        <Box width={fullWidth ? '100%' : 'auto'}>
            {label !== null && (
                <div style={{ marginBottom: '8px', paddingLeft: paddingleft }}>
                    <label>
                        <DefaultLabelTypo variant="label" style={{ color: 'rgba(21, 56, 98, 0.5)' }}>
                            {label}
                        </DefaultLabelTypo>
                        {typeKey === 'card_number' && helpertextcardtype && <br style={{ display: width < 883 ? 'block' : 'none' }} />}
                        <Typography variant="label" sx={{ color: '#D03C3C', marginLeft: '15px' }}>
                            {helpertextcardtype}
                        </Typography>
                    </label>
                </div>
            )}
            {props.InputProps ? (
                <TextField {...props} />
            ) : (
                <DefaultInputStyled
                    {...props}
                    type={getRealType(type)}
                    error={error}
                    label={
                        <Typography variant="label" sx={{ color: 'rgba(21, 56, 98, 0.5)' }}>
                            {label}
                        </Typography>
                    }
                    value={value}
                    helpertext={helpertext}
                    variant="outlined"
                    fullWidth={fullWidth}
                    onKeyUp={onKeyUp}
                    onChange={onChange}
                    onBlur={onBlur}
                    inputlabelprops={{
                        shrink: true
                    }}
                    inputProps={{
                        'aria-autocomplete': 'none',
                        autoComplete: 'new-password',
                        spellCheck: 'false'
                    }}
                    placeholder={placeholder}
                    sx={

                        ['password', 'zipSearch'].includes(type) ? {
                            '.MuiInputAdornment-root': {
                                position: 'absolute',
                                right: '18px',
                                '.MuiSvgIcon-root': {
                                    width: '18px',
                                    height: '18px'
                                }
                            },
                            '.MuiInputBase-input': {
                                '::-ms-reveal': {
                                    display: 'none'
                                }
                            }
                        } : { ...props.sx }
                    }
                    endAdornment={getEndAdornment(type, value) || null}
                />
            )}
            {helpertext && (
                <div style={{ marginTop: '8px', paddingLeft: paddingleft }}>
                    <label>
                        <TextHeleperTypo variant="label">{helpertext}</TextHeleperTypo>
                    </label>
                </div>
            )}
        </Box>
    )
})

const TextHeleperTypo = styled(Typography)(({ theme }) => ({
    fontFamily: 'Poppins, Inter',
    fontStyle: 12,
    color: '#D03C3C',
    fontWeight: 500
}))

export default DefaultInput
